module.exports = __webpack_public_path__ + "static/media/majorA4.7816e9c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA4.wav
// module id = S8eu
// module chunks = 0